module.exports = __webpack_public_path__ + "static/media/item_18_8_comp.eca698ea.png";